import { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { CaseView } from '../../caseViewContainer'
import Modal from '../../../../reusable/modal'
import { CreateNewCaseModalContent } from '../../../../modalContent/createNewCaseContent'
import { EmptyState, Section, cx } from '../../../../../ui'
export interface statsProps {
    data: any
    client: any
    requestData: any
}
export const AllCases = (props: statsProps) => {
    const { data, client, requestData } = props
    const [currentCase, setCurrentCase] = useState(data[0])
    const [createNewCase, setCreateNewCase] = useState(false)
    const [recentStatsData, setRecentStatsData] = useState<any>({})
    useEffect(() => {
        console.log('data:', data)
    }, [data])

    const handleClick = (caseRef: string) => {
        const caseToSet = data.find((matter: any) => matter.case_ref == caseRef)
        setCurrentCase(caseToSet)
    }

    const handleAddNewClaimClick = () => {
        toggleModal()
    }

    const buttonState = (dupe: number, cancelled: number) => {
        if (dupe === 1) {
            return 'Duplicate'
        }
        if (cancelled === 1) {
            return 'Cancelled'
        }
        return 'Active'
    }

    const toggleModal = () => {
        setCreateNewCase(!createNewCase)
    }

    return (
        <Section
            className={styles.allCasesView}
            title="All cases"
            description={data?.length > 0 ? `${data.length} linked matter${data.length === 1 ? '' : 's'}` : undefined}
        >
            {data?.length > 0 ? (
                <>
                    <div className={styles.caseSelector} role="tablist" aria-label="Linked cases">
                        {data.map((item: any, k: number) => {
                            const state = buttonState(item.marked_duplicate, item.cancelled)
                            const selected = currentCase?.case_ref == item.case_ref
                            return (
                                <button
                                    type="button"
                                    role="tab"
                                    aria-selected={selected}
                                    className={cx(
                                        styles.caseButton,
                                        selected && styles.selected,
                                        state === 'Active' ? styles.activeCase : state === 'Cancelled' ? styles.inactiveCase : styles.duplicateCase
                                    )}
                                    key={k}
                                    onClick={() => handleClick(item.case_ref)}
                                >
                                    <span className={styles.caseState}>{state}</span>
                                    <span className={styles.caseRef}>{item.case_ref}</span>
                                </button>
                            )
                        })}
                    </div>
                    <CaseView data={currentCase} />
                </>
            ) : (
                <EmptyState title="No linked matters" description="This client has no linked matters yet." />
            )}

            <Modal modalState={createNewCase} previewModalAction={toggleModal} title="Add a claim">
                <CreateNewCaseModalContent clientData={client} closeModal={toggleModal} refreshData={requestData} />
            </Modal>
        </Section>
    )
}
